<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Card di contenimento dello scadenzario -->
    <b-card title="Scadenzario Aziendale" class="mr-1 ml-1">

      <b-row class="mb-2">
        <!-- Form per interagire con la tabella -->
        <b-col cols="12" md="2">
          <!-- Elementi visualizzati per pagina -->
          <b-form-group id="group-page-size"
              label="Elementi visualizzati:"
              label-for="page-size">

            <b-form-select id="page-size"
                          v-model="page_size"
                          :options="page_size_opt">
            </b-form-select>
          </b-form-group>
        </b-col>
        <!-- Ricerca nella tabella -->
        <b-col cols="12" md="3">
          <!-- Input box per filtraggio elementi per stringa -->
          <b-form-group id="group-filtro-tabella"
            label="Ricerca per termine:"
            label-for="filtro_tabella"
            description="Digita per ricercare all'interno degli elementi della tabella ( non ha effetto sui dati scaricati )">
            <b-form-input
              id="filtro_tabella"
              v-model="filter">
              </b-form-input>
          </b-form-group>
        </b-col>
        <!-- Pulsante per scaricamento dati -->
        <b-col cols="12" md="3">
          <b-button id="download-button"
                    :disabled="download_btn_disabled"
                    variant="primary"
                    @click="download_data">
            <span v-if="download_btn_disabled">
              <b-spinner variant="light" clas="mr-1" small></b-spinner>
              Attendere, scaricamento in corso...
            </span>
            <span v-else>
              <b-icon icon="cloud-download" class="mr-1"></b-icon> Scarica i dati
            </span>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- Tabella dello scadenzario -->
          <!-- no-provider-sorting e no-provider-filtering evita che per ogni azione
              di sorting o filtraggio venga chiamato il backend, ma venga fatto dalla
              tabella stessa. Non usiamo la proprietà stacked su schermi piccoli prediligendo
              il formato tabellare. -->
          <b-table responsive
                  stacked="sm"
                  :per-page="page_size"
                  :current-page="page"
                  :filter="filter"
                  :no-provider-filtering="true"
                  :no-provider-sorting="true"
                  :items="item_provider"
                  :fields="fields"
                  show-empty>

            <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
                  chiamata la funzione che prende i dati get_table_items --->
            <template v-slot:table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
                <strong class="text-primary">Caricamento...</strong>
              </div>
            </template>

            <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
                  la proprietà "show-empty" alla tabella -->
            <template v-slot:empty>
              <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/> Nessun elemento disponibile</p>
            </template>

            <!-- Slot che visualizza un messaggio quando il filtro non restituisce risultati, deve essere aggiunta
                  la proprietà "show-empty" alla tabella -->
            <template v-slot:emptyfiltered>
              <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento trovato</p>
            </template>
          </b-table>

          <!-- Paginatore della tabella -->
          <b-pagination v-model="page" :per-page="page_size" :total-rows="items_tot" align="center"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import moment from 'moment'
import axios from 'axios'
import fileDownload from 'js-file-download'

export default {
    name: 'ScadenzarioAzi',
    data () {
      return {
        tagline_elem : [ { text : "Scadenzario Aziendale", link: "office-scadenzario-azi" } ],

        // Abilitazione/disabilitazione bottone di scariamento dati.
        download_btn_disabled : false,

        // Numero totale di elementi ( per la paginazione )
        items_tot : 0,

        // Numero di elementi per ogni pagina
        page_size : 50,

        // Numero di pagine che è possibile visualizzare
        page_size_opt: [
          { value: 10,  text: '10'  },
          { value: 25,  text: '25'  },
          { value: 50,  text: '50'  },
          { value: 100, text: '100' },
          { value: 500, text: '500' }
        ],

        // Pagina corrente della tabella
        page: 1,

        // Stringa per filtrare gli elementi della tabella
        filter : null,

        // Definizione dei campi della tabella ( abbiamo anche il campo )
        // id_dipendente che però non usiamo.
        fields : [
          {
            key: 'cognome',
            label: 'Cognome',
            sortable: true,
            class: 'text-center'
          },
          {
            key: 'nome',
            label: 'Nome',
            sortable: true,
            class: 'text-center'
          },
          {
            key: 'credito_tot',
            label: 'Credito Disponibile',
            sortable: true,
            class: 'text-center'
          },
          {
            key: 'credito_art51c3',
            label: 'Di cui ART 51 C.3',
            sortable: true,
            class: 'text-center'
          },
          {
            key: 'scadenza_credito',
            label: 'Data Scadenza Credito più Vicina',
            sortable: true,
            class: 'text-center'
          }
        ]
      }
    },
    methods: {
      /**
       * Funzione che va a caricare gli item nella tabella.
       */
      item_provider : function ( ctx, callback ) {

        let params = { page : ctx.currentPage, page_size : ctx.perPage }

        axios.get( apiUrl.welfareapi.get_scadenzario_aziendale, { params : params } )
        .then( ( response ) => {

          // Gli elementi totali
          this.items_tot = response.data.count;

          // Array degli elementi in tabella che andiamo a compilare
          let items = new Array()

          // Dobbiamo verificare la data di scadenza:
          // - se il credito è in scadenza coloriamo la riga di rosso
          // - se scaduto coloriamo la riga di grigio
          // - se la data è quella del 1970-01-01 00:00:00 vuol dire che non c'è
          //   nessun credito in essere.
          // - se nulla dei precedenti è vero significa che il credito è attivo.
          for ( let elem of response.data.results ) {

            // Mettiamo da parte una stringa con la data di scadenza in italiano,
            // non usiamo il filtro perchè potrebbe servirci per costruire una
            // stringa espicativa sotto.
            let data_scad_ita = moment( elem.scadenza_credito );
            data_scad_ita = data_scad_ita.format( 'DD-MM-YYYY HH:mm:ss' );

            if ( this.is_credito_in_scadenza( elem.scadenza_credito ) ) {

              elem['_rowVariant'] = 'danger';
              elem.scadenza_credito = data_scad_ita;

            } else if ( this.is_credito_scaduto( elem.scadenza_credito ) ) {

              elem['_rowVariant'] = 'secondary';

              // Il credito è scaduto o non è in essere ( data di scadenza come inizio
              // dello unixepoch ), controllo qual'è il caso e setto la stringa.
              const unix_epoch = moment( '1970-01-01 00:00:00' );
              const scadenza = moment( elem.scadenza_credito );

              if ( scadenza.isSame( unix_epoch ) ){
                elem.scadenza_credito = "Nessun credito in essere presente."
              } else {
                elem.scadenza_credito = "Credito scaduto il " + data_scad_ita + ". Nessun credito in essere presente."
              }

            } else {
              // Credito non scaduto
              elem.scadenza_credito = data_scad_ita;
            }

            // Inserisco il dato dell'array degli elementi da tornare per la tabella
            items.push( elem );

          }

          // Ordino gli utenti alfabeticamente e li ritorno alla table
          items.sort( (a,b) => {
            let cna = a.cognome + " " + a.nome;
            let cnb = b.cognome + " " + b.nome;
            return (cna > cnb ) ? 1 : ( (cnb > cna ) ? -1 : 0 )
          });

          callback( items );

        })
        .catch( ( error ) => {
          let mess = "Si è verificato un errore nel caricamento dei dati:"
          generalLib.backend_error_message_box( this, error.response.data, mess );
          callback([]);
        });

        // Must return null or undefined to signal b-table that callback is being used
        return null
      },
      /**
       * Data la stringa con la data e l'ora di scadenza del credito verifica
       * se è entro i 10 giorni da oggi. Se si torna True, segnalando che il credito
       * è in scadenza.
       *
       * - date_time_string: data e ora del credito.
       */
      is_credito_in_scadenza : function ( date_time_string ) {

        const DAY_LIMIT = 10;

        const today = moment();
        const scadenza = moment( date_time_string );
        let diff = scadenza.diff( today, 'days' );

        // Se i giorni sono sotto il limite ma non negativi ( il che
        // indica che il credito è già scaduto ), allora torniamo true.
        // Se invece la differenza è zero significa che siamo proprio nel
        // giorno di scadenza, l'ultimo giorno cioè in cui il credito è
        // ancora valido.
        return ( diff >= 0 && diff <= DAY_LIMIT ) ? true : false;

      },
      /**
       * Controlla se la data di scadenza è oltre oggi, se si torna true segnalando che il
       * credito è scaduto.
       *
       * - date_time_string: data e ora del credito.
       */
      is_credito_scaduto : function ( date_time_string ) {

        const today = moment();
        const scadenza = moment( date_time_string );
        let diff = scadenza.diff( today, 'days' );

        // Se la differenza è negativa l'ultimo giorno utile ( quello di scadenza del credito )
        // è passato, quindi il credito è ko e torniamo true.
        return ( diff < 0 ) ? true : false;

      },
      /**
       * Esegue lo scaricamento dei dati dal backend.
       */
      download_data : function () {

        this.download_btn_disabled = true;

        // La chiamata è la medesima della tabella ma con il parametro download a true
        let params = { download : true }

        axios.get( apiUrl.welfareapi.get_scadenzario_aziendale, { params : params } )
        .then( ( response ) => {
          // Prendiamo il nome dall'header content-disposition
          let nome_file = generalLib.get_nome_file( response );
          // Usiamo js-file-donwload per salvare il file sul client
          fileDownload( response.data, nome_file );
          this.download_btn_disabled = false;
        })
        .catch( (error) => {
          this.download_btn_disabled = false;
          generalLib.backend_error_message_box( this, error.response.data );
        });
      }
    },
    components : {
      PageTagline,
      SwitcherAziende
    }
}
</script>

<style scoped>
/* Allineamento pulsante di scaricamento agli altri componenti del form
   quando siamo sugli schermi grandi */
@media (min-width: 768px) {
  #download-button {
    margin-top: 2.0em;
  }
}
</style>